import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSolicitationFormSchema } from './useSolicitationFormSchema';

export function useSolicitationForm() {
	const solicitationFormSchema = useSolicitationFormSchema();

	const form = useForm({
		mode: 'all',
		resolver: yupResolver(solicitationFormSchema),
	});

	return form;
}
